export default __webpack_public_path__ + "static/media/GrillazGif.c7b2d0c3.gif";